import moment from "moment";
import { useEffect, useState } from "react";
import "react-quill/dist/quill.snow.css"; // Import Quill styles
import { getVessels } from "../../utils/ApiCalls/SpecialPage";
import Swal from "sweetalert2";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import { Divider } from "antd";
import CruisePageSelector from "./CruisePageSelector";

const SailingDateDataInput = ({ newsletter }) => {
  const [vesselOption, setVesselOptions] = useState([]);
  const [, dispatch] = useDataLayerValue();

  // Reusable cruise date formatting helper (same as in CruisePageSelector)
  const formatCruiseTitle = (sailingDate, duration = 7) => {
    const startDate = moment(sailingDate);
    const endDate = startDate.clone().add(duration, 'days');
    return `${startDate.format("DD MMM")} to ${endDate.format("DD MMM YYYY")} / ${duration} Nights`;
  };

  useEffect(() => {
    getOptionLocation();
  }, []);
  const getOptionLocation = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });

    let vessels = await getVessels();
    if (vessels.error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: vessels.error,
      });
    } else {
      setVesselOptions(vessels);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  return (
    <div>
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-body">
              <h4 style={{ fontWeight: "bold" }}>Manage Sailing content</h4>
              <p>
                {vesselOption.find((item) => item.id === newsletter?.vessel_id)?.name}{" "}
                - {formatCruiseTitle(newsletter?.sailing_date, newsletter?.duration || 7)}
              </p>
            </div>
            <div style={{ paddingLeft: "10px", paddingRight: "10px" }}>
              <Divider style={{ border: "1px solid gray" }} />
            </div>
            {newsletter?.vessel_id && vesselOption?.length > 0 && (
              <CruisePageSelector
                vessel_id={newsletter?.vessel_id}
                sailing_date={newsletter?.sailing_date}
                vesselOptions={vesselOption}
                sailing_id={newsletter?.id}
                sailing_page={newsletter}
              />
            )}
          </div>
          <div className="pt-3"></div>
        </div>
      </section>
    </div>
  );
};

export default SailingDateDataInput;
